// src/components/LAB/LABCreateActivityModal.js
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import { useTranslation } from '../../i18n';
import runningIcon from '../../assets/icons/running.png';
import cyclingIcon from '../../assets/icons/cycling.png';
import swimIcon from '../../assets/icons/swim.png';
import strengthIcon from '../../assets/icons/strength.png';
import walkIcon from '../../assets/icons/walk.png';
import otherIcon from '../../assets/icons/other.png';
import challengeIcon from '../../assets/icons/challenge.png';

const SPORT_ICON_MAP = {
  correr: runningIcon, ciclismo: cyclingIcon, nadar: swimIcon,
  fuerza: strengthIcon, caminar: walkIcon, otro: otherIcon, competencia: challengeIcon,
};

const API = API_BASE_URL;

const SPORTS = [
  { value: 'correr', label: 'Correr' },
  { value: 'ciclismo', label: 'Ciclismo' },
  { value: 'nadar', label: 'Nadar' },
  { value: 'fuerza', label: 'Fuerza' },
  { value: 'caminar', label: 'Caminar' },
  { value: 'otro', label: 'Otro' },
  { value: 'competencia', label: 'Competencia' },
];

export default function LABCreateActivityModal({ show, onHide, date, athleteId, trainerId, onSaved }) {
  const [form, setForm] = useState({
    type: 'correr', title: '', description: '',
    planned: { duracion: '', distancia: '', tss: '', calorias: '', desnivel_positivo: '' },
    competition: { eventName: '', sport: 'correr', distance: '', priority: 'B', city: '', targetTime: '' }
  });
  const isCompetition = form.type === 'competencia';
  const setComp = (k, v) => setForm(f => ({ ...f, competition: { ...f.competition, [k]: v } }));
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setPlanned = (k, v) => setForm(f => ({ ...f, planned: { ...f.planned, [k]: v } }));

  const handleSave = async () => {
    if (!form.type) return;
    if (isCompetition) {
      if (!form.competition.eventName?.trim()) { setError('Nombre del evento es requerido'); return; }
    } else if (!form.description || !form.description.trim()) {
      setError('Descripción es requerida');
      return;
    }
    if (!isCompetition && !form.planned.duracion && !form.planned.distancia) {
      setError('Duración o Distancia es requerida');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const dateObj = new Date(date);
      const payload = isCompetition ? {
        assignedTo: athleteId,
        trainer: trainerId || localStorage.getItem('userId'),
        type: 'competencia',
        title: form.competition.eventName,
        description: form.competition.distance ? `${form.competition.sport} \u00b7 ${form.competition.distance}` : form.competition.sport,
        date: dateObj.toISOString(),
        start: dateObj.toISOString(),
        planned: { duracion: form.competition.targetTime || '', distancia: form.competition.distance || '' },
        completed: { duration:'', distance:'', tss:0, calories:0 },
        draggable: true,
        external: false,
        isCompetition: true,
        competition: form.competition,
      } : {
        assignedTo: athleteId,
        trainer: trainerId || localStorage.getItem('userId'),
        type: form.type,
        title: form.title || form.type,
        description: form.description || ' ',
        date: dateObj.toISOString(),
        start: dateObj.toISOString(),
        planned: form.planned,
        completed: { duration:'', distance:'', tss:0, calories:0 },
        draggable: true,
        external: false,
      };
      await axios.post(`${API}/api/activities/add`, payload, { headers: { Authorization: `Bearer ${token}` } });
      onSaved?.();
      onHide();
      setForm({ type:'correr', title:'', description:'', planned:{ duracion:'', distancia:'', tss:'', calorias:'', desnivel_positivo:'' } });
    } catch(e) {
      setError('Error al guardar la actividad');
    }
    setSaving(false);
  };

  const dateLabel = date ? new Date(date).toLocaleDateString('es-CL', { weekday:'long', day:'numeric', month:'long', year:'numeric' }) : '';

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton style={{ background:'#1e3a5f', color:'#fff' }}>
        <Modal.Title style={{ fontSize:15 }}>{t('activityDetails.createActivity') || 'Crear actividad'} · {dateLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding:'20px 24px' }}>
        {error && <div style={{ background:'#fef2f2', color:'#dc2626', padding:'8px 12px', borderRadius:6, marginBottom:12, fontSize:13 }}>{error}</div>}

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:6 }}>Deporte</label>
          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
            {SPORTS.map(s => (
              <button key={s.value} onClick={() => set('type', s.value)}
                style={{ padding:'6px 12px', borderRadius:20, border:`1.5px solid ${form.type===s.value?'#1e3a5f':'#e5e7eb'}`,
                  background: form.type===s.value?'#1e3a5f':'#fff', color: form.type===s.value?'#fff':'#374151',
                  cursor:'pointer', fontSize:12, fontFamily:'inherit' }}>
                <img src={SPORT_ICON_MAP[s.value]} alt={s.value} width="16" height="16" style={{objectFit:'contain', marginRight:4}} />
                {s.label}
              </button>
            ))}
          </div>
        </div>

        {isCompetition ? (<>
          <div style={{ marginBottom:12 }}>
            <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:4 }}>Nombre del evento *</label>
            <input value={form.competition.eventName} onChange={e => setComp('eventName', e.target.value)}
              placeholder="Ej: Maratón de Santiago"
              style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'8px 12px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
          </div>
          <div style={{ marginBottom:12 }}>
            <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:6 }}>Deporte</label>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {[{v:'correr',l:'Correr'},{v:'ciclismo',l:'Ciclismo'},{v:'nadar',l:'Nadar'},{v:'triatlon',l:'Triatlón'}].map(s => (
                <button key={s.v} onClick={() => setComp('sport', s.v)} type="button"
                  style={{ padding:'5px 10px', borderRadius:16, border:`1.5px solid ${form.competition.sport===s.v?'#f59e0b':'#e5e7eb'}`,
                    background: form.competition.sport===s.v?'#fef3c7':'#fff', color:'#374151', cursor:'pointer', fontSize:11, fontFamily:'inherit' }}>
                  {s.l}
                </button>
              ))}
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:12 }}>
            <div>
              <label style={{ fontSize:11, color:'#6b7280', display:'block', marginBottom:3 }}>Distancia / Formato</label>
              <input value={form.competition.distance} onChange={e => setComp('distance', e.target.value)}
                placeholder="42K, Sprint, Olímpico..."
                style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'6px 10px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
            </div>
            <div>
              <label style={{ fontSize:11, color:'#6b7280', display:'block', marginBottom:3 }}>Prioridad</label>
              <div style={{ display:'flex', gap:6 }}>
                {['A','B','C'].map(p => (
                  <button key={p} onClick={() => setComp('priority', p)} type="button"
                    style={{ flex:1, padding:'6px', borderRadius:6, border:`1.5px solid ${form.competition.priority===p? (p==='A'?'#dc2626':p==='B'?'#f59e0b':'#6b7280') :'#e5e7eb'}`,
                      background: form.competition.priority===p? (p==='A'?'#fef2f2':p==='B'?'#fef3c7':'#f9fafb') :'#fff',
                      color: form.competition.priority===p? (p==='A'?'#dc2626':p==='B'?'#d97706':'#374151') :'#9ca3af',
                      cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit' }}>
                    {p}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:4 }}>
            <div>
              <label style={{ fontSize:11, color:'#6b7280', display:'block', marginBottom:3 }}>Ciudad</label>
              <input value={form.competition.city} onChange={e => setComp('city', e.target.value)}
                placeholder="Santiago"
                style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'6px 10px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
            </div>
            <div>
              <label style={{ fontSize:11, color:'#6b7280', display:'block', marginBottom:3 }}>Objetivo de tiempo</label>
              <input value={form.competition.targetTime} onChange={e => setComp('targetTime', e.target.value)}
                placeholder="3:15:00"
                style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'6px 10px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
            </div>
          </div>
        </>) : (<>
        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:4 }}>Título</label>
          <input value={form.title} onChange={e => set('title', e.target.value)}
            placeholder={`Ej: Entrenamiento de ${form.type}`}
            style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'8px 12px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
        </div>

        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:4 }}>Descripción / Instrucciones</label>
          <textarea value={form.description} onChange={e => set('description', e.target.value)}
            rows={3} placeholder="Descripción del entrenamiento..."
            style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'8px 12px', fontSize:13, outline:'none', fontFamily:'inherit', resize:'vertical' }} />
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:4 }}>
          {[
            { key:'duracion', label:'Duración (hh:mm:ss)', placeholder:'01:00:00' },
            { key:'distancia', label:'Distancia (km)', placeholder:'10' },
            { key:'tss', label:'TSS planificado', placeholder:'80' },
            { key:'calorias', label:'Calorías', placeholder:'500' },
          ].map(f => (
            <div key={f.key}>
              <label style={{ fontSize:11, color:'#6b7280', display:'block', marginBottom:3 }}>{f.label}</label>
              <input value={form.planned[f.key]} onChange={e => setPlanned(f.key, e.target.value)}
                placeholder={f.placeholder}
                style={{ width:'100%', border:'1px solid #e5e7eb', borderRadius:6, padding:'6px 10px', fontSize:13, outline:'none', fontFamily:'inherit' }} />
            </div>
          ))}
        </div>
        </>)}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onHide} style={{ background:'#6b7280', color:'#fff', border:'none', borderRadius:6, padding:'8px 16px', cursor:'pointer', fontFamily:'inherit' }}>{t('common.cancel') || 'Cancelar'}</button>
        <button onClick={handleSave} disabled={saving}
          style={{ background:'#1e3a5f', color:'#fff', border:'none', borderRadius:6, padding:'8px 16px', cursor:'pointer', fontFamily:'inherit', opacity:saving?0.7:1 }}>
          {saving ? (t('common.saving') || 'Guardando...') : (t('common.save') || 'Guardar')}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
